import { render, staticRenderFns } from "./PaymentsBreakdownPage.vue?vue&type=template&id=0f7f7d70&"
import script from "./PaymentsBreakdownPage.vue?vue&type=script&lang=js&"
export * from "./PaymentsBreakdownPage.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsBreakdownPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports